import React, { createContext, useContext } from 'react';

const JerseyContext = createContext(null);

export function useJerseyData() {
    return useContext(JerseyContext);
}

export default function JerseyDataProvider(props) {
    return (
        <JerseyContext.Provider value={{...props}}>
            {props.children}
        </JerseyContext.Provider>
    );
}
